<template>
  <div id="not-found">
    <p><a class="bi" href="/">pricewagon</a></p>
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <div class="links">
      <p><a href="/">영양제웨건으로 가기</a></p>
      <p><a href="https://mandu.pricewagon.net">만두웨건으로 가기</a></p>
    </div>
  </div>
</template>

<script>
import {
    BNavItem
} from 'bootstrap-vue'

export default {
  name: 'PageNotFound',
  components: {
    BNavItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#not-found {
  height: 100vh;
  text-align: center;
  padding: 50px;
  color: #000;
}
a {
  text-decoration: none;
}
.bi {
  font-size: 2rem;
  font-weight: 700;
  color: #1E3E72;
}
h1 {
  font-size: 7rem;
}
h2 {
  font-size: 3rem;
}
li {
  display: block;
}
.links {
  margin: 40px;
}
.links > p > a {
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue